
  const getSS_Site_ID = () => {
    const SiteIDs = {
      "en": "qsz8vg",
      "fr": "0vlyhb"
    }
    return SiteIDs[window.Shopify.locale] || undefined
  }

  // --- Fetch Autocomplete (Searchspring) ---
  async function fetchSearchSpringAutocomplete(query) {
    const SITE_ID = getSS_Site_ID()
    if (!SITE_ID || !query || query.length < 2) return null;
    const base = `https://${SITE_ID}.a.searchspring.io`;
    const url = new URL(`${base}/api/search/autocomplete.json`);
    url.searchParams.set('q', query);
    url.searchParams.set('siteId', SITE_ID); // required by your setup
    url.searchParams.set('resultsFormat', "native");
    url.searchParams.set('resultsPerPage', "3");

    // Optional: availability prefilter; adjust to your index field
    // url.searchParams.set('bgfilter', 'availability:true');

    const resp = await fetch(url.toString(), { credentials: 'omit' });
    if (!resp.ok) throw new Error(`Searchspring ${resp.status}`);
    return resp.json();
  }
  async function fetchSearchSpringSuggestions(query) {
    const SITE_ID = getSS_Site_ID()
    if (!SITE_ID || !query || query.length < 2) return null;
    const base = `https://${SITE_ID}.a.searchspring.io`;
    const url = new URL(`${base}/api/suggest/query`);
    url.searchParams.set('q', query);
    url.searchParams.set('siteId', SITE_ID); // required by your setup
    url.searchParams.set('suggestionCount', "3");
    url.searchParams.set('language', window.Shopify.locale);

    // Optional: availability prefilter; adjust to your index field
    // url.searchParams.set('bgfilter', 'availability:true');

    const resp = await fetch(url.toString(), { credentials: 'omit' });
    if (!resp.ok) throw new Error(`Searchspring ${resp.status}`);
    return resp.json();
  }

  async function fetchSearchSpringSearch(query) {
    const SITE_ID = getSS_Site_ID()
    if (!SITE_ID || !query || query.length < 2) return null;
    const base = `https://${SITE_ID}.a.searchspring.io`;
    const url = new URL(`${base}/api/search/search.json`);
    url.searchParams.set('q', query);
    url.searchParams.set('siteId', SITE_ID); // required by your setup
    url.searchParams.set('resultsFormat', "native");
    url.searchParams.set('resultsPerPage', "3");
    url.searchParams.set('bgfilter.ss_available', "1");
    url.searchParams.set('bgfilter.status', "active");

    // Optional: availability prefilter; adjust to your index field
    // url.searchParams.set('bgfilter', 'availability:true');

    const resp = await fetch(url.toString(), { credentials: 'omit' });
    if (!resp.ok) throw new Error(`Searchspring ${resp.status}`);
    return resp.json();
  }
  
  function isNumber(value) {
    return !isNaN(value);
  }
  // --- Inject into existing LI structure ---
  function injectResultsIntoList(results) {
    const LIST_SELECTOR = '#predictive-search-results-products-list';

    const ul = document.querySelector(LIST_SELECTOR);
    if (!ul) return;
    ul.style.display = "grid"
    
    const items = Array.isArray(results) ? results : [];
    if (!items.length) return;

    // Use existing <li>s as templates; clone if we need more
    const existingLis = Array.from(ul.querySelectorAll('li.predictive-search__list-item'));
    const template = existingLis[0] ? existingLis[0].cloneNode(true) : null;

    // Helper: clean a price element so your formatter can run again
    const resetPriceNode = (el) => {
      if (!el) return;
      el.dataset.formatted = ''; // your script checks this
      // Remove child <s> wrapper if present; we will re-add when on sale
      const s = el.querySelector('s');
      if (s) {
        el.textContent = s.textContent || s.innerText || s.textContent;
      }
    };

    // Map Searchspring product to one <li>
    const applyToLi = (li, product, i) => {
      const core = product?.mappings?.core || {};
      const fields = product?.fields || {};
      const name = product?.name || core.name || fields.name || product?.title || 'Untitled';
      const url  = product?.url  || core.url  || fields.url  || '#';
      const img  = product?.thumbnailImageUrl || product?.imageUrl || core.thumbnailImageUrl || core.imageUrl || fields.thumbnailImageUrl || fields.imageUrl || '';
      const brand = fields.brand || fields.vendor || core.brand || '';

      // Price handling (raw numbers; your formatter will localize)
      const price = toNumber(product?.price ?? core.price ?? fields.price);
      const sale  = toNumber(product?.salePrice ?? core.salePrice ?? fields.salePrice);
      const onSale = sale != null && isFinite(sale) && sale > 0 && price != null && sale < price;

      // Links (image + title)
      const mediaLink = li.querySelector('a.media-wrapper');
      const titleLink = li.querySelector('a.reversed-link');
      if (mediaLink) mediaLink.href = url;
      if (titleLink) {
        titleLink.href = url;
        titleLink.textContent = name;
      }

      // Image
      const imgEl = li.querySelector('img');
      if (imgEl) {
        imgEl.src = img;
        imgEl.alt = name;
      }

      // Vendor/brand
      const vendorEl = li.querySelector('.text-subtext.text-sm');
      if (vendorEl) vendorEl.textContent = brand || vendorEl.textContent;

      // Prices (reuse your markup)
      const priceRoot = li.querySelector('.f-price');
      const regularSpanTop = li.querySelector('.f-price__regular .f-price-item--regular');
      const saleSpan = li.querySelector('.f-price__sale .f-price-item--sale');
      const compareSpan = li.querySelector('.f-price__sale .f-price-item--regular');

      // Reset formatted flags so your observer can reformat
      [regularSpanTop, saleSpan, compareSpan].forEach(resetPriceNode);

      // Set values
      if (onSale) {
        priceRoot?.classList.add('f-price--on-sale');
        if (saleSpan) saleSpan.textContent = toDisplay(sale);
        if (compareSpan) {
          // ensure it’s wrapped in <s> like your snippet
          compareSpan.innerHTML = `<s>${toDisplay(price)}</s>`;
        }
        if (regularSpanTop) regularSpanTop.textContent = toDisplay(price);
      } else {
        priceRoot?.classList.remove('f-price--on-sale');
        if (regularSpanTop) regularSpanTop.textContent = toDisplay(price);
        if (saleSpan) saleSpan.textContent = '';
        if (compareSpan) compareSpan.innerHTML = '';
      }

      // (Optional) sold-out flag if you have an in-stock field
      // const inStock = product?.inStock ?? fields.inStock ?? true;
      // priceRoot?.classList.toggle('f-price--sold-out', !inStock);

      // Keep IDs predictable for a11y
      li.id = `predictive-search-option-product-${i + 1}`;
      li.setAttribute('aria-selected', 'false');
    };

    // Render up to the max of (existing count or items length); clone if needed
    const needed = Math.max(items.length, existingLis.length || 0);
    for (let i = 0; i < needed; i++) {
      const product = items[i];
      let li = existingLis[i];
      if (!li) {
        if (!template) break;
        li = template.cloneNode(true);
        ul.appendChild(li);
      }
      if (product) {
        applyToLi(li, product, i);
        li.style.display = '';
      } else {
        // Hide extra Shopify LIs if fewer SS items
        li.style.display = 'none';
      }
    }

    // Trigger your formatter to localize the updated numbers
    document.dispatchEvent(new Event('variant:change'));
  }

  function toNumber(value) {
    if (value == null) return null;
    const n = typeof value === 'number' ? value : Number(String(value).replace(/[^\d.,-]/g, '').replace(',', '.'));
    return isFinite(n) ? n : null;
  }
  function toDisplay(n) {
    if (n == null) return '';
    // Provide raw numeric string; your existing script will reformat by locale
    return (Math.round(n * 100) / 100).toFixed(2);
  }

const updatePredictiveWithSearchspring = async (query) => {
  try {
    // Optional: short-circuit trivial input
    if (!query) return 0;
    const suggestions = await fetchSearchSpringSuggestions(query);

    // Prefer completed suggestion → else numeric query → else an alternative token 
    const completed = suggestions?.suggested?.completed;

    if(!completed) { 
      const json = await fetchSearchSpringSearch(query);
      const products = json?.results ?? [];
      // injectResultsIntoList(products);
      return products;
    }

    const completedToken = Array.isArray(completed) && completed[0]?.token;

    const altGroups = suggestions?.alternatives;
    const altToken =
      Array.isArray(altGroups) &&
      altGroups[0]?.completed &&
      Array.isArray(altGroups[0].completed) &&
      altGroups[0].completed[0]?.token;

    const search = completedToken ?? (isNumber(query) ? query : altToken ?? query);

    const json = await fetchSearchSpringAutocomplete(search);
    const products = json?.results ?? [];
    // injectResultsIntoList(products);

    return products; // handy if you want to know how many were rendered
  } catch (e) {
    console.error('[SS] fallback to Shopify predictive (error fetching SS):', e);
    return 0;
  }
};



class PredictiveSearch extends HTMLFormElement {
  constructor() {
    super();
    this.cachedMap = new Map();
    this.focusElement = this.input;
    this.resetButton.addEventListener('click', this.clear.bind(this));
    this.input.addEventListener('input', FoxTheme.utils.debounce(this.onChange.bind(this), 300));
    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.searchContent = this.querySelector('.search__content');
    this.searchRecommendationEmpty = this.dataset.searchRecommendationEmpty === 'true';

    const isTemplateSearch = this.closest('.template-search');
    if (isTemplateSearch) {
      document.addEventListener('click', this.handleClickOutside.bind(this));
    }
  }

  get input() {
    return this.querySelector('input[type="search"]');
  }
  get resetButton() {
    return this.querySelector('button[type="reset"]');
  }

  onFocus(event) {
    if (this.closest('.template-search')) {
      document.body.classList.add('predictive-search-open');
      if (this.getQuery().length === 0) {
        return;
      }
      const url = this.setupURL().toString();
      this.renderSection(url, event);
    }
  }
  getQuery() {
    return this.input.value.trim();
  }
  clear(event = null) {
    event && event.preventDefault();
    if (this.searchRecommendationEmpty && this.searchContent) {
      this.searchContent.classList.add('hidden');
    }
    this.input.value = '';
    this.input.focus();
    this.removeAttribute('results');
  }

  setupURL() {
    const url = new URL(`${FoxTheme.routes.shop_url}${FoxTheme.routes.predictive_search_url}`);
    return (
      url.searchParams.set('q', this.getQuery()),
      url.searchParams.set('resources[limit]', this.dataset.resultsLimit || 3),
      url.searchParams.set('resources[limit_scope]', 'each'),
      url.searchParams.set('section_id', FoxTheme.utils.getSectionId(this)),
      url
    );
  }

  onChange() {
    if (this.getQuery().length === 0) {
      this.clear();
      return;
    }
    const url = this.setupURL().toString();
    this.renderSection(url);
  }

  renderSection(url) {
    this.cachedMap.has(url) ? this.renderSectionFromCache(url) : this.renderSectionFromFetch(url);
  }

  renderSectionFromCache(url) {
    const responseText = this.cachedMap.get(url);
    this.renderSearchResults(responseText), this.setAttribute('results', '');
  }

  renderSectionFromFetch(url) {
    // Indicate that loading has started
    this.setAttribute('loading', 'true');
    this.resetButton.classList.add('btn--loading');

    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text();
      })
      .then((responseText) => {
        // Process and cache the fetched data
        this.renderSearchResults(responseText);
        this.cachedMap.set(url, responseText);
      })
      .catch((error) => {
        console.error('Error fetching data: ', error);
        this.setAttribute('error', 'Failed to load data');
      })
      .finally(() => {
        // Remove the loading attribute in both success and error cases
        this.removeAttribute('loading');
        this.resetButton.classList.remove('btn--loading');
        this.setAttribute('results', 'true');
      });
  }
  renderSearchResults(responseText) {
    const id = 'PredictiveSearchResults-' + FoxTheme.utils.getSectionId(this);
    const targetElement = document.getElementById(id);

    if (targetElement) {
      const parser = new DOMParser();
      const parsedDoc = parser.parseFromString(responseText, 'text/html');
      const contentElement = parsedDoc.getElementById(id);

      if (contentElement) {
        // render seachspring result after shopify results to prevent any issues
        updatePredictiveWithSearchspring(this.getQuery()).then((products) => {

          if(products.length == 0) return
          this.searchContent?.classList.remove('hidden');
          targetElement.innerHTML = contentElement.innerHTML;

          injectResultsIntoList(products);
        })

      } else {
        console.error(`Element with id '${id}' not found in the parsed response.`);
      }
    } else {
      console.error(`Element with id '${id}' not found in the document.`);
    }
  }

  handleClickOutside(event) {
    if (!this.contains(event.target)) {
      setTimeout(() => {
        document.body.classList.remove('predictive-search-open');
      });
    }
  }
}
customElements.define('predictive-search', PredictiveSearch, { extends: 'form' });

class SearchDrawer extends DrawerComponent {
  constructor() {
    super();

    const trigger = document.querySelector('[aria-controls="SearchDrawer"]');
    if (trigger) {
      trigger.replaceWith(trigger.cloneNode(true));
      const newTrigger = document.querySelector(
        '[aria-controls="SearchDrawer"]'
      );

      this.drawerInner = this.querySelector(".drawer__inner");

      newTrigger.addEventListener("mouseenter", () =>
        this.openWithDelay()
      );

      newTrigger.addEventListener("mouseleave", () =>
        clearTimeout(this.openTimeout)
      );

      this.drawerInner?.addEventListener("mouseenter", () =>
        clearTimeout(this.closeTimeout)
      );
      newTrigger.addEventListener("mouseenter", () =>
        clearTimeout(this.closeTimeout)
      );

      document.addEventListener("mousemove", (e) => {
        if (this.open) {
          const insideDrawer = this.drawerInner?.contains(e.target);
          const insideTrigger = newTrigger.contains(e.target);

          if (!insideDrawer && !insideTrigger) {
            this.closeWithDelay();
          }
        }
      });
    }
  }

  get requiresBodyAppended() {
    return false;
  }
  get input() {
    return this.querySelector('input[type="search"]');
  }
  get focusElement() {
    return this.querySelector('input[type="search"]');
  }

  openWithDelay() {
    clearTimeout(this.openTimeout);
    this.openTimeout = setTimeout(() => this.show(), 500); 
  }

  closeWithDelay() {
    clearTimeout(this.closeTimeout);
    this.closeTimeout = setTimeout(() => this.hide(), 1000);
  }

  // Force scroll unlock after closing
  handleAfterHide() {
    super.handleAfterHide?.();
    document.body.classList.remove("modal-show", "modal-showing");
    document.body.classList.remove("boost-sd__search-opening");
  }
}
customElements.define("search-drawer", SearchDrawer);
